import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
const baseUrl = process.env.REACT_APP_API_BASE_URL;

const UserDetails = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${baseUrl}/users/view/${id}`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        const result = await response.json();

        if (result?.status === true && result?.data) {
          setUser(result.data);
          // console.log("Fetched users:", result);
        } else {
          throw new Error(result?.message || "Failed to fetch user details");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  return (
    <div className="flex bg-gray-900 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <div className="p-8">
          {loading ? (
            <p>Loading user details...</p>
          ) : error ? (
            <p className="text-red-500">Error: {error}</p>
          ) : user ? (
            <>
            <div className="bg-gray-800 p-6 rounded-lg shadow mb-5">
              <h2 className="text-2xl font-semibold mb-4 text-white">User Details</h2>
              <div className="flex items-center space-x-4 mb-4">
                <img
                  src={user.profilePicture}
                  alt="Profile"
                  className="w-20 h-20 rounded-full border"
                />
                <div>
                  <h1 className="text-xl text-white">{user.username}</h1>
                </div>
              </div>
            </div>

            <div className="bg-gray-800 p-6 rounded-lg shadow">
              <h2 className="text-2xl font-semibold mb-4 text-white">Personal Information</h2>
              <div className="flex flex-wrap items-center space-x-4 mb-4 gap-20 text-white">
                <div>
                    <p className="text-sm text-gray-300">Email Address:</p>
                    <b>{user.email}</b>
                </div>
                <div>
                    <p className="text-sm text-gray-300">Coin:</p>
                    <b>{user.coin || '0'}</b>
                </div>
                <div>
                    <p className="text-sm text-gray-300">Referral Code:</p>
                    <b>{user.referralCode || 'N/A'}</b>
                </div>
            </div>

            <div className="flex flex-wrap items-center space-x-4 mb-4 gap-20 text-white">
                <div>
                    <p className="text-sm text-gray-300">Active Mining:</p>
                    <b>{user.isMiningActive || '0'}</b>
                </div>
                <div>
                    <p className="text-sm text-gray-300">Mining Speed (ph):</p>
                    <b>{user.perHourMiningSpeed || 'N/A'}</b>
                </div>
            <div>
                </div>
              </div>
            </div>
            </>
          ) : (
            <p>No user data available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDetails;